import { NonPIIAccount, Quote } from '@sxm-de/dev-kits/microservices-sdk/types';
import { SxmTypeAccount } from '@sxm-de/dev-kits/web-sdk/types';
import { mapSmsAddressToAddress } from './map-sms-address-to-address';
import { mapSmsBillingSummaryToPaymentMethod } from './map-sms-billing-summary-to-payment-method';
import { mapSmsBillingSummaryToBillingStatus } from './map-sms-billing-summary-to-billing-status';

export function mapSmsAccountToAccount(
    smsAccount: NonPIIAccount,
    currentQuote: Quote | null,
): SxmTypeAccount {
    return {
        accountNumber: smsAccount.accountNumber,
        username: smsAccount.userName,
        firstName: smsAccount.firstName,
        lastName: smsAccount.lastName,
        fullName: [smsAccount.firstName, smsAccount.lastName || '']
            .join(' ')
            .trim(),
        phone: smsAccount.phone,
        email: smsAccount.email,
        serviceAddress: smsAccount.serviceAddress
            ? mapSmsAddressToAddress(smsAccount.serviceAddress)
            : null,
        billingAddress: smsAccount.billingAddress
            ? mapSmsAddressToAddress(smsAccount.billingAddress)
            : null,
        paymentMethod: mapSmsBillingSummaryToPaymentMethod(
            smsAccount.billingSummary,
        ),
        billingStatus: mapSmsBillingSummaryToBillingStatus(
            smsAccount,
            currentQuote,
        ),
    };
}
